'use strict';

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  // Don't track while developing.
  if (process.env.NODE_ENV === 'production' && typeof window.yaCounter !== 'undefined' && typeof window.yaCounter.hit === 'function') {
    window.yaCounter.hit((location || {}).pathname);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-yandex-metrika/gatsby-browser.js
// module id = 362
// module chunks = 231608221292675